import React, { useEffect, useState } from "react";
import ProductRepository from "../../data/repository/ProductRepository";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import Logo from "../../assets/images/LOGO DRINKSIFY.png";

const PreviewNFTView = () => {
  const [searchParams] = useSearchParams();
  const qrid = searchParams.get("qrid");
  const { i18n } = useTranslation();
  const [nft, setNft] = useState(null);
  const productRepository = new ProductRepository();
  const { t } = useTranslation();
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProductDetail = async () => {
      try {
        const productData = await productRepository.getNFTByIdToken(
          qrid,
          i18n.language
        );
        setNft(productData);
      } catch (error) {
        setError(error);
        console.log(error);
      }
    };
    fetchProductDetail();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#160F31",
        boxSizing: "border-box",
      }}
    >
      {error ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1rem",
          }}
        >
          <Typography variant="h6" style={{ color: "#F36E1E" }}>
            {t("myNFTs.errorNft")}
          </Typography>
          <Typography variant="body2" style={{ color: "#fff" }}>
            <a
              href="javascript:history.back()"
              style={{ color: "#fff", textDecoration: "none" }}
            >
              {t("myNFTs.back")}
            </a>
          </Typography>
        </div>
      ) : (
        <>
          {nft ? (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                gap: "1rem",
                padding: "1rem",
                boxSizing: "border-box",
              }}
            >
              <img
                src={Logo}
                alt="Logo"
                style={{ width: "100px", marginBottom: "1rem" }}
              />
              <img
                style={{
                  maxWidth: "400px",
                  width: "100%",
                  height: "400px",
                  objectFit: "cover",
                  boxShadow: "rgb(243 110 30 / 18%) 0px -1px 43px 1px",
                  borderRadius: "6px",
                  marginBottom: "1rem",
                }}
                src={nft?.product?.image}
                alt={nft?.product?.name}
              />
              <Typography
                variant="h3"
                style={{ color: "#F36E1E" }}
                fontWeight={500}
              >
                {nft?.product?.name}
              </Typography>
              <Typography variant="h5" style={{ color: "#fff" }}>
                {nft?.user?.name?.charAt(0).toUpperCase() +
                  nft?.user?.name?.slice(1)}{" "}
                {nft?.user?.surname?.charAt(0).toUpperCase() +
                  nft?.user?.surname?.slice(1)}
              </Typography>
              <Typography variant="body1" style={{ color: "#fff" }}>
                {nft?.cellar?.name}
              </Typography>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <Typography variant="body1" fontWeight={600} color="#fff">
                  {t("myNFTs.estadoNft")}:{" "}
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight={600}
                  color={nft?.isRequested ? "success" : "error"}
                >
                  {nft?.isRequested
                    ? t("myNFTs.solicitado")
                    : t("myNFTs.noSolicitado")}
                </Typography>
              </Box>
            </div>
          ) : (
            <div>
              <CircularProgress size={80} style={{ color: "#F36E1E" }} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default PreviewNFTView;
